import React from "react";
import "../style/CarOverviewSaldo.css";

function CarOverviewWithSaldo({ carro, saldo, onClick }) {
  const imageUrl = (carro.imagenes[0] || "").replace("http://", "https://");

  function formatNumberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  return (
    <div onClick={onClick} className="car-updated-saldo">
      <div className="car-card-image-wrap">
        <img
          src={imageUrl}
          alt={`${carro.marca} ${carro.modelo}`}
          className="car-card-img"
        />
        {carro.thirdPartySeller && (
          <span className="third-party-badge third-party-badge--overlay">
            Vendedor Externo
          </span>
        )}
      </div>
      <div className="info-part-s">
        <p className="car-model-s">
          {carro.marca} {carro.modelo} {carro.anio}
        </p>
        {carro.lote !== "0" && (
          <p className="lote-s">Lote {carro.lote}</p>
        )}
        <div className="card-prices">
          <div className="card-price-block">
            <span className="card-price-label">Precio</span>
            <span className="price-home-s" translate="no">
              L.{formatNumberWithCommas(carro.precio)}
            </span>
          </div>
          <div className="card-saldo-block">
            <span className="card-saldo-label">Saldo</span>
            <span className="saldo" translate="no">
              L.{formatNumberWithCommas(saldo)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CarOverviewWithSaldo;
